import { CS_CDN_ENDPOINTS } from '../utils/constants/endpoints'
import { AXIOS_METHODS } from '../utils/constants/enum'
import {
    SingleStaticPageResponse,
    DynamicPageResponse,
    PostLandingPageResponse,
    PostLandingState,
    AllPostsResponse,
    SinglePostResponse,
    SinglePostState,
    HomePageResponse,
    SubCategoryResponse,
    SubCategory,
    BoosterLandingPageResponse,
    BoosterLandingState,
    EventResponse,
    DynamicNavigationResponse,
} from '../utils/types/ContentStack'
import { Axios } from './axios'
import {
    SubCategoryPostsQuery,
    PostByUrlQuery,
    HomePageQuery,
    PostsLandingPageQuery,
    SingleStaticPageQuery,
    SubCategoriesQuery,
    PostsQuery,
    NavigationQuery,
    LoyaltyAppQuery,
} from './graphQL/query'

export const GetStaticPage = async (url: string) => {
    try {
        const response = await Axios.csApiCall<
            string,
            SingleStaticPageResponse
        >(SingleStaticPageQuery(url))
        if (response.data?.all_static_page?.items.length > 0) {
            return response.data.all_static_page.items[0]
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}

export const GetDynamicPage = async (query: string) => {
    try {
        const response = await Axios.csApiCall<string, DynamicPageResponse>(
            query
        )
        if (response.data?.all_dynamic_page?.items.length > 0) {
            return response.data.all_dynamic_page.items[0]
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}
export const GetBoosterLandingPage = async (query: string) => {
    try {
        const response = await Axios.csApiCall<
            string,
            BoosterLandingPageResponse
        >(query)
        if (
            response.data?.all_dynamic_page?.items.length > 0 &&
            response.data?.all_boosters.items
        ) {
            const data: BoosterLandingState = {
                page: response.data.all_dynamic_page.items[0],
                booster: response.data.all_boosters.items,
            }
            return data
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}
export const GetPostsLandingPage = async (url: string, category: string) => {
    try {
        const response = await Axios.csApiCall<string, PostLandingPageResponse>(
            PostsLandingPageQuery(url, category)
        )
        if (
            response.data?.all_dynamic_page?.items.length > 0 &&
            response.data?.all_post.items.length > 0
        ) {
            const data: PostLandingState = {
                page: response.data.all_dynamic_page.items[0],
                posts: response.data.all_post.items,
            }
            return data
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}

export const GetSubcategoryPosts = async (
    subCategory: SubCategory,
    category: string
) => {
    try {
        const response = await Axios.csApiCall<string, AllPostsResponse>(
            SubCategoryPostsQuery(subCategory.title, category)
        )
        if (response.data?.all_post.items.length > 0) {
            return response.data?.all_post.items
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}

export const GetPostByUrl = async (url: string) => {
    try {
        const response = await Axios.csApiCall<string, SinglePostResponse>(
            PostByUrlQuery(url)
        )
        if (response.data?.all_post.items.length > 0) {
            const data: SinglePostState = {
                post: response.data.all_post.items[0],
            }
            return data
        }
    } catch (error) {
        // error handling
    }
}

export const GetHomePage = async () => {
    try {
        const response = await Axios.csApiCall<string, HomePageResponse>(
            HomePageQuery()
        )
        if (response.data?.all_home?.items.length > 0) {
            return response.data.all_home.items[0]
        }
    } catch (error) {
        // error handling
    }
}

export const GetPosts = async () => {
    try {
        const response = await Axios.csApiCall<string, AllPostsResponse>(
            PostsQuery()
        )
        if (response.data?.all_post?.items.length > 0) {
            return response.data.all_post.items
        }
    } catch (error) {
        // error handling
    }
}

export const GetSubCategories = async (category: any) => {
    try {
        const response = await Axios.csApiCall<string, SubCategoryResponse>(
            SubCategoriesQuery(category)
        )
        if (response.data?.all_sub_category?.items.length > 0) {
            return response.data.all_sub_category.items
        }
    } catch (error) {
        // error handling
    }
}

export const GetEventList = async (
    date: string,
    skip: number,
    rpp: number,
    filterBy: string,
    orderBy: string
) => {
    try {
        const response = await Axios.csCdnApiCall<EventResponse>(
            AXIOS_METHODS.GET,
            CS_CDN_ENDPOINTS.SEARCH(date, skip, rpp, filterBy, orderBy)
        )
        if (response.entries.length) {
            return response
        }
    } catch (error) {
        // error handling
    }
}

export const GetDynamicNavigation = async (navigation: string) => {
    try {
        const response = await Axios.csApiCall<
            string,
            DynamicNavigationResponse
        >(NavigationQuery(navigation))
        if (response.data?.all_navigation?.items.length > 0) {
            return response.data.all_navigation.items[0]
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}

export const GetLoyaltyAppData = async () => {
    try {
        const response = await Axios.csApiCall<string, any>(LoyaltyAppQuery())
        if (
            response?.data?.web_app_config?.itemsConnection?.edges?.length > 0
        ) {
            return response?.data?.web_app_config?.itemsConnection?.edges
        } else {
            // error handling
        }
    } catch (error) {
        // error handling
    }
}
